import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
// import { TOI_LIVE_DOMAIN } from '../../../../constants';
import s from './Socials.scss';

class Socials extends React.Component {
  render() {
    const { colorTheme } = this.props;
    const theme = colorTheme ? s[colorTheme] : '';
    return (
      <ul className={`${s.sociable} ${theme}`}>
        <li className={s.fb}>
          <Link
            target="_blank"
            rel="nofollow noreferrer"
            className={s['sports-sprite']}
            data-ga="top_header|social_profile_icons|social_fb"
            to="https://www.facebook.com/etimesofficial"
            title="Facebook"
          />
        </li>
        <li className={s.twitter}>
          <Link
            target="_blank"
            rel="nofollow noreferrer"
            className={s['sports-sprite']}
            data-ga="top_header|social_profile_icons|social_twitter"
            to="https://twitter.com/etimes"
            title="X"
          />
        </li>
      </ul>
    );
  }
}

Socials.propTypes = {
  colorTheme: PropTypes.string,
};
Socials.defaultProps = {
  colorTheme: '',
};
export default Socials;
